/**
 * Helper function to construct location coordinates as lat,lng string from the
 * Google Geocoder response  https://developers.google.com/maps/documentation/geocoding/requests-geocoding#GeocodingResponses
 * @param {Object} location Google geocoder response
 * @returns {string} string in format '182.333, -123.45' or '';
 */
const makeLocationString = (location) => {
  if (!location) {
    return '';
  }
  return Object.values(location[0]?.geometry?.location)
    .map((v) => (typeof v === 'function' ? v?.() : v))
    .join(', ');
};

export default makeLocationString;
